PS.setMode = function (mode) {
  if (!PS.state.selectedCategory) {
    PS.showCategoryView();
    return;
  }

  const duty = mode === 'duty';

  document.getElementById('mode-duty-btn').classList.toggle('is-active', duty);
  document.getElementById('mode-model-btn').classList.toggle('is-active', !duty);

  if (duty) {
    PS.showDutyInputView();
  } else {
    PS.showSearchWrapper();
    document.getElementById('duty-input-view').style.display = 'none';
    document.getElementById('duty-results-view').style.display = 'none';
    document.getElementById('model-view').style.display = 'block';
    document.getElementById('detail-view').style.display = 'none';
  }
};

PS.showDetailView = function () {
  let match = PS.state.currentMatches[PS.state.currentSelectedIndex];

  if (!match) {
    return;
  }

  // If the duty search was filtered to a single pole count, carry that into
  // selectedMotorPoles so the detail view honours it. Without this, the
  // refine step below infers poles from match.selectedSpeedRpm which can
  // round to the wrong pole count (e.g. a 2950 rpm match reads as 2-pole
  // even though the user searched for 4-pole only).
  const dutyPoleFilter = PS.state.duty?.poleFilter;
  if (!PS.state.selectedMotorPoles && dutyPoleFilter?.length === 1) {
    PS.state.selectedMotorPoles = dutyPoleFilter[0];
  }

  // Search results are built before any motor brand is known, so their RPM
  // only approximates synchronous speed - refine against the real
  // auto-selected motor now that we're about to display it in detail.
  match = PS.refineMatchWithEffectiveMotor(match);

  // The real motor's nameplate speed (e.g. 1450 rpm) can be lower than the
  // synchronous speed the search used (e.g. 1500 rpm).  The affinity-law head
  // drop can push the curve below the duty point even though the search found
  // a valid trim.  Re-solve for the correct trim at the actual motor speed so
  // the detail view always opens with the curve at or above the duty point,
  // matching what motor Apply would produce.
  if (match && match.headMargin < 0 && !match.isVertical) {
    const motor = PS.getEffectiveMotor(match);
    const familyCurves = PS.getCurvesArray().filter(
      curve => PS.getPumpFamily(curve) === match.family
    );
    const speedOptions = {
      frequencyHz: match.selectedFrequencyHz,
      poles: motor.poles,
      motor
    };
    const refit = PS.findBestTrimForMotorChange(familyCurves, match, speedOptions);
    if (refit && refit.headMargin >= 0) match = refit;
  }

  PS.state.currentMatches[PS.state.currentSelectedIndex] = match;
  PS.state.extraCurveSpecs = [];
  PS.state.dutyPointVisible = true;
  PS.state.openAdjustSections = new Set();
  PS.state.dutyPoints = [];
  // System curve is per-pump (its static head is fitted to this pump's duty),
  // so reset it on each new selection. selectionMode is deliberately NOT reset
  // here - Basic/Advanced is a global preference that persists across pumps.
  PS.state.systemCurve = { enabled: false, staticHeadBase: null };

  document.getElementById('duty-input-view').style.display = 'none';
  document.getElementById('duty-results-view').style.display = 'none';
  document.getElementById('model-view').style.display = 'none';
  document.getElementById('detail-view').style.display = 'block';

  PS.drawDetailChart('detail-chart', 'detail', match, PS.state.detailModes);

  PS.renderDetailSummary('detail-summary', match, 'detail-pump-title');
  PS.renderAdjustmentPanel('detail-adjustment-panel', match, 'detail-chart', 'detail', 'detail-summary');
  PS.updateChartModeAvailability(match, 'detail');
};

PS.showResultsView = function () {
  document.getElementById('detail-view').style.display = 'none';
  PS.showDutyResultsView();

  PS.drawChart(
    'pump-chart',
    'duty',
    PS.state.currentMatches,
    PS.state.visibleMatchIndexes,
    PS.state.dutyModes,
    PS.state.currentSelectedIndex
  );
};

PS.wireChartTabs = function () {
  document
    .querySelectorAll('[data-model-chart-mode], [data-detail-chart-mode]')
    .forEach(button => {
      const mode = button.dataset.modelChartMode || button.dataset.detailChartMode;
      const config = PS.chartModeConfig[mode];

      if (config) {
        button.style.borderColor = config.color;
      }

      button.addEventListener('click', () => {
        const modeSet = PS.state.detailModes;

        if (modeSet.has(mode)) {
          if (modeSet.size > 1) {
            modeSet.delete(mode);
          }
        } else {
          modeSet.add(mode);
        }

        PS.updateChartTabStates();

        const match = PS.state.currentMatches[PS.state.currentSelectedIndex];

        if (!match) {
          return;
        }

        if (document.getElementById('model-view').style.display !== 'none') {
          PS.drawChart('model-chart', 'model', [match], new Set([0]), PS.state.detailModes, 0);
        }

        if (document.getElementById('detail-view').style.display !== 'none') {
          PS.drawDetailChart('detail-chart', 'detail', match, PS.state.detailModes);
        }
      });
    });

  PS.updateChartTabStates();
};

// Onga fixed pumps have no power/efficiency coefficients and some have no
// NPSHr data either, so each of these chart modes is gated independently -
// head is always available (it's the curve the pump was matched on).
PS.chartModeAvailabilityCheckers = {
  power: PS.hasUsablePowerData,
  npsh: PS.hasUsableNpshData,
  efficiency: PS.hasUsableEfficiencyData
};

PS.updateChartModeAvailability = function (match, viewPrefix) {
  Object.keys(PS.chartModeAvailabilityCheckers).forEach(mode => {
    const available = !!match && PS.chartModeAvailabilityCheckers[mode](match);

    document
      .querySelectorAll(`[data-${viewPrefix}-chart-mode="${mode}"]`)
      .forEach(button => {
        button.disabled = !available;

        if (!available) {
          PS.state.detailModes.delete(mode);
        }
      });

    const note = document.getElementById(`${viewPrefix}-${mode}-unavailable`);
    if (note) {
      note.style.display = available ? 'none' : 'block';
    }
  });

  PS.updateChartTabStates();
};

PS.updateChartTabStates = function () {
  document
    .querySelectorAll('[data-model-chart-mode], [data-detail-chart-mode]')
    .forEach(button => {
      const mode = button.dataset.modelChartMode || button.dataset.detailChartMode;
      const config = PS.chartModeConfig[mode];
      const active = PS.state.detailModes.has(mode);

      button.classList.toggle('is-active', active);

      if (config && active) {
        button.style.background = config.color;
        button.style.borderColor = config.color;
        button.style.color = '#fff';
      } else if (config) {
        button.style.background = '#fff';
        button.style.borderColor = config.color;
        button.style.color = '';
      }
    });
};

// Refreshes whatever view is currently on screen so a mid-session unit
// change (see PS.wireUnitsModal) takes effect immediately, without losing
// the customer's current duty/selection state the way re-running a search
// or reopening a view from scratch would. Base-unit values on each match
// never change here - only the PS.unitSettings-driven display formatting
// does, so simply re-invoking each view's existing render calls on the
// data already in PS.state is enough; nothing needs recalculating.
PS.refreshDisplayedUnits = function () {
  if (document.getElementById('detail-view').style.display !== 'none') {
    const match = PS.state.currentMatches[PS.state.currentSelectedIndex];
    if (!match) return;

    PS.drawDetailChart('detail-chart', 'detail', match, PS.state.detailModes);
    PS.renderDetailSummary('detail-summary', match, 'detail-pump-title');
    PS.renderAdjustmentPanel('detail-adjustment-panel', match, 'detail-chart', 'detail', 'detail-summary');
    PS.updateChartModeAvailability(match, 'detail');
    return;
  }

  if (document.getElementById('model-view').style.display !== 'none') {
    const match = PS.state.currentMatches[PS.state.currentSelectedIndex];
    if (!match) return;

    PS.drawChart('model-chart', 'model', [match], new Set([0]), PS.state.detailModes, 0);
    PS.renderDetailSummary('model-detail-summary', match, 'model-pump-title');
    PS.renderAdjustmentPanel('model-adjustment-panel', match, 'model-chart', 'model', 'model-detail-summary');
    PS.updateChartModeAvailability(match, 'model');
    return;
  }

  if (document.getElementById('duty-results-view').style.display !== 'none') {
    // PS.renderMatches always resets selection/visibility state (it's built
    // for a fresh search result) - snapshot and restore around it so a unit
    // change doesn't silently collapse the customer's current multi-select
    // comparison back down to just the top match.
    const savedVisible = new Set(PS.state.visibleMatchIndexes);
    const savedSelected = PS.state.currentSelectedIndex;
    const savedFocused = PS.state.focusedMatchIndex;

    PS.renderMatches(PS.state.currentMatches);

    PS.state.visibleMatchIndexes = savedVisible;
    PS.state.currentSelectedIndex = savedSelected;
    PS.state.focusedMatchIndex = savedFocused;

    PS.updateMatchButtonStates();
    PS.drawChart('pump-chart', 'duty', PS.state.currentMatches, PS.state.visibleMatchIndexes, PS.state.dutyModes, PS.state.currentSelectedIndex);
    PS.renderSearchSummary();
  }
};

// Engineering units modal - flow/head-pressure/power display units, openable
// from every view (the button lives in the persistent page header, outside
// any view-specific wrapper) rather than only from the duty input form.
PS.wireUnitsModal = function () {
  const modal = document.getElementById('units-modal');
  if (!modal || !document.getElementById('units-btn')) return;

  document.getElementById('units-btn').addEventListener('click', () => {
    document.getElementById('units-flow').value = PS.unitSettings.flow;
    document.getElementById('units-head').value = PS.unitSettings.head;
    document.getElementById('units-power').value = PS.unitSettings.power;
    modal.style.display = 'block';
  });

  document.getElementById('units-close').addEventListener('click', () => {
    modal.style.display = 'none';
  });

  document.getElementById('units-apply').addEventListener('click', () => {
    PS.unitSettings.flow = document.getElementById('units-flow').value;
    PS.unitSettings.head = document.getElementById('units-head').value;
    PS.unitSettings.power = document.getElementById('units-power').value;

    // Keep the duty input form's own per-field unit dropdowns in sync so
    // they don't show stale units if the customer goes back to that view.
    const dutyFlowUnit = document.getElementById('duty-flow-unit');
    const dutyHeadUnit = document.getElementById('duty-head-unit');
    if (dutyFlowUnit) dutyFlowUnit.value = PS.unitSettings.flow;
    if (dutyHeadUnit) dutyHeadUnit.value = PS.unitSettings.head;

    modal.style.display = 'none';

    PS.refreshDisplayedUnits();
    PS.saveSession();
  });
};

// Basic <-> Advanced selection-stage toggle (persistent header). Basic (the
// default) hides engineering-only tools; Advanced reveals the System Curve
// section and Bearing Load Analysis in the adjustment panel and the system-
// curve overlay on the chart. Mirrors the Units-modal pattern: flip a global
// setting, re-render whichever detail/model view is on screen (no re-search),
// and persist.
PS.syncModeToggleButtons = function () {
  const advanced = PS.state.selectionMode === 'advanced';
  const basicBtn = document.getElementById('selection-mode-basic-btn');
  const advBtn = document.getElementById('selection-mode-advanced-btn');

  if (basicBtn) {
    basicBtn.classList.toggle('is-active', !advanced);
    basicBtn.setAttribute('aria-pressed', String(!advanced));
  }
  if (advBtn) {
    advBtn.classList.toggle('is-active', advanced);
    advBtn.setAttribute('aria-pressed', String(advanced));
  }
};

// Only the single-pump detail/model views expose the advanced tools, so those
// are the only views that need re-rendering when the mode flips. The results
// list and duty form are identical in both modes.
PS.refreshDisplayedMode = function () {
  const match = PS.state.currentMatches[PS.state.currentSelectedIndex];
  if (!match) return;

  if (document.getElementById('detail-view').style.display !== 'none') {
    PS.drawDetailChart('detail-chart', 'detail', match, PS.state.detailModes);
    PS.renderAdjustmentPanel('detail-adjustment-panel', match, 'detail-chart', 'detail', 'detail-summary');
    return;
  }

  if (document.getElementById('model-view').style.display !== 'none') {
    PS.drawChart('model-chart', 'model', [match], new Set([0]), PS.state.detailModes, 0);
    PS.renderAdjustmentPanel('model-adjustment-panel', match, 'model-chart', 'model', 'model-detail-summary');
  }
};

PS.wireModeToggle = function () {
  const basicBtn = document.getElementById('selection-mode-basic-btn');
  const advBtn = document.getElementById('selection-mode-advanced-btn');
  if (!basicBtn || !advBtn) return;

  const applyMode = mode => {
    if (PS.state.selectionMode === mode) return;
    PS.state.selectionMode = mode;
    PS.syncModeToggleButtons();
    PS.refreshDisplayedMode();
    PS.saveSession();
  };

  basicBtn.addEventListener('click', () => applyMode('basic'));
  advBtn.addEventListener('click', () => applyMode('advanced'));

  PS.syncModeToggleButtons();
};

PS.wireSearchSettingsModal = function () {
  const modal = document.getElementById('search-settings-modal');
  if (!modal || !document.getElementById('search-settings-btn')) return;

  document.getElementById('search-settings-btn').addEventListener('click', () => {
    document.getElementById('search-ideal-bep').value = PS.searchSettings.idealBepWindowPercent;
    document.getElementById('search-max-bep').value = PS.searchSettings.maxBepWindowPercent;
    document.getElementById('search-vsd-max-margin').value = PS.searchSettings.vsdMaxHeadMarginPercent;
    document.getElementById('search-vsd-strict-pole-order').checked = PS.searchSettings.vsdStrictPoleOrder;
    modal.style.display = 'block';
  });

  document.getElementById('search-settings-close').addEventListener('click', () => {
    modal.style.display = 'none';
  });

  document.getElementById('search-settings-apply').addEventListener('click', () => {
    PS.searchSettings.idealBepWindowPercent =
      Number(document.getElementById('search-ideal-bep').value) || 15;

    PS.searchSettings.maxBepWindowPercent =
      Number(document.getElementById('search-max-bep').value) || 35;

    PS.searchSettings.vsdMaxHeadMarginPercent =
      Number(document.getElementById('search-vsd-max-margin').value) || 10;

    PS.searchSettings.vsdStrictPoleOrder =
      document.getElementById('search-vsd-strict-pole-order').checked;

    modal.style.display = 'none';
  });
};

document.addEventListener('DOMContentLoaded', async () => {
  try {
    await PS.loadData();

    // Category landing page
    document.querySelectorAll('.pump-category-tile:not(:disabled)').forEach(tile => {
      tile.addEventListener('click', () => {
        PS.state.selectedCategory = tile.dataset.category;
        // Pump type dropdowns and the Pump application fieldset are both
        // scoped to selectedCategory - rebuild them for the tile just picked.
        PS.populatePumpTypeDropdowns();
        PS.updateApplicationFilterVisibility?.();
        PS.setMode('duty');
      });
    });

    document.getElementById('category-back-btn').addEventListener('click', () => {
      PS.state.selectedCategory = null;
      PS.populatePumpTypeDropdowns();
      PS.updateApplicationFilterVisibility?.();
      PS.showCategoryView();
      PS.saveSession();
    });

    PS.populatePumpTypeDropdowns();
    PS.populateFluidDropdown();
    PS.populateMaterialDropdown();
    PS.wireChartTabs();
    PS.wireUnitsModal();
    PS.wireModeToggle();
    PS.wireSearchSettingsModal();
    PS.wireCadDownloadModal();
    PS.wireBearingModal();

    // Null-safe addEventListener — silently skips if the element isn't in the
    // DOM. Prevents a missing element in one Shopify theme version from
    // crashing the entire wiring block and leaving all other buttons unwired.
    const on = (id, event, handler) => document.getElementById(id)?.addEventListener(event, handler);

    on('curve-export-generate', 'click', PS.generateCurveSheet);
    on('curve-export-close', 'click', () => {
      document.getElementById('curve-export-modal').style.display = 'none';
    });

    on('fluid-select', 'change', PS.updateFluidProperties);
    on('fluid-temperature', 'change', PS.updateFluidProperties);

    on('mode-duty-btn', 'click', () => { PS.setMode('duty'); });
    on('mode-model-btn', 'click', () => { PS.setMode('model'); });

    on('model-pump-type', 'change', PS.populateModelFamilies);
    on('model-pump-family', 'change', PS.populateMotorSelections);
    on('model-motor-selection', 'change', PS.updateModelTrimDefault);

    PS.wireSpeedRangeVisibility();

    on('pump-select-btn', 'click', () => {
      const duty = PS.captureDutyInputs();
      const result = document.getElementById('pump-result');

      if (
        !Number.isFinite(duty.flow) ||
        !Number.isFinite(duty.totalHead) ||
        duty.flow <= 0 ||
        duty.totalHead <= 0
      ) {
        result.innerHTML = '<strong>Please enter a valid duty point.</strong>';
        return;
      }

      if (
        duty.controlType === 'speedRange' &&
        (!Number.isFinite(duty.speedRangeMinRpm) || !Number.isFinite(duty.speedRangeMaxRpm) ||
          duty.speedRangeMinRpm <= 0 || duty.speedRangeMaxRpm <= duty.speedRangeMinRpm)
      ) {
        result.innerHTML = '<strong>Please enter a valid min/max speed range.</strong>';
        return;
      }

      // Submergible (Jung Pumpen) pumps split into drainage-only and
      // sewage-capable models - the customer must say which they need
      // before search runs, since a sewage duty must never surface a
      // drainage-only pump. See PS.updateApplicationFilterVisibility.
      if (PS.state.selectedCategory === 'submergible' && !duty.applicationType) {
        result.innerHTML = '<strong>Please select a pump application (Drainage or Sewage) before searching.</strong>';
        return;
      }

      const matches = PS.findPumpMatches(duty.flow, duty.totalHead, duty.controlType, duty);

      PS.renderMatches(matches);
      PS.showDutyResultsView();
    });

    on('pump-material-select', 'change', event => {
      const val = event.target.value;
      const selectedMatch = PS.state.currentMatches?.[PS.state.currentSelectedIndex];
      const variants = selectedMatch?.curve?.familyMetadata?.materialVariants;

      if (variants?.length) {
        // Variant family (PT/PW): update selected series and re-render without re-searching
        PS.state.selectedVariantSeries = val;
        PS.populateMaterialDropdown();
        PS.renderMatches(PS.state.currentMatches);
      } else {
        // Standard material derating: re-run full search so head curves update
        PS.state.selectedMaterial = val;
        const duty = PS.state.duty;
        if (!duty) return;
        const matches = PS.findPumpMatches(duty.flow, duty.totalHead, duty.controlType, duty);
        PS.renderMatches(matches);
      }
    });

    on('model-load-btn', 'click', () => {
      const familyCurves = PS.getModelFamilyCurves();
      const motorSelect = document.getElementById('model-motor-selection');

      if (!familyCurves.length) {
        return;
      }

      const isFixedPump = familyCurves.every(curve => curve.fixedPump);

      if (!isFixedPump && !motorSelect.value) {
        return;
      }

      const isVertical = familyCurves.every(PS.isVerticalMultistage);
      let match;

      if (isFixedPump) {
        match = PS.findModelMatchForFixedPump(familyCurves[0]);
      } else if (isVertical) {
        match = PS.findModelMatchForVerticalCurve(familyCurves, motorSelect.value);
      } else {
        const selected = (PS.state.modelMotorOptions || [])[Number(motorSelect.value)];

        if (!selected) {
          return;
        }

        // The size was picked brand-agnostically (see getMotorSizeOptionsForFamily) -
        // settle on whichever brand actually stocks it, keeping the currently
        // selected brand if it already covers this size rather than always
        // resetting to the first match.
        const coveringBrands = PS.getBrandsForMotorSize(selected.motor.poles, selected.motor.powerKw);
        const currentBrandCovers = coveringBrands.some(({ value }) => value === PS.state.selectedMotorBrand);

        if (!currentBrandCovers) {
          PS.state.selectedMotorBrand = coveringBrands[0]?.value || PS.state.selectedMotorBrand;
        }

        PS.state.selectedMotorPoles = selected.motor.poles;

        const trimMm = Number(document.getElementById('model-trim').value) || selected.defaultTrimMm;

        // Auto-size the motor to the actual trim, at the real motor's own
        // full-load speed (see selectMotorForModelTrim). A trim beyond what the
        // picked size supports (e.g. 217mm needs 30.4kW at 2955rpm, past a 30kW
        // motor) gets bumped up to the smallest motor that does cover it - the
        // 30kW cap at 216mm / 37kW at 217mm the paper curves show, and
        // brand-specific since a WEG W22 spins faster than a TECO TE3. Never
        // sized below the size the customer explicitly picked, so a deliberate
        // over-size still stands.
        const sizedMotor = PS.selectMotorForModelTrim(
          selected.baseCurve, familyCurves, trimMm, selected.motor.poles, PS.state.selectedMotorBrand
        );
        const loadMotor = sizedMotor && sizedMotor.powerKw > selected.motor.powerKw ? sizedMotor : selected.motor;

        // Keep the brand consistent with whichever motor we actually settled on
        // (an auto-bump may have crossed into a size only some brands stock).
        const loadCoveringBrands = PS.getBrandsForMotorSize(loadMotor.poles, loadMotor.powerKw);
        if (loadCoveringBrands.length && !loadCoveringBrands.some(({ value }) => value === PS.state.selectedMotorBrand)) {
          PS.state.selectedMotorBrand = loadCoveringBrands[0].value;
        }

        PS.state.selectedMotorKw = loadMotor.powerKw;
        match = PS.findModelMatchForTrim(selected.baseCurve, trimMm, loadMotor);
      }

      if (!match) {
        PS.renderDetailSummary('model-detail-summary', null, 'model-pump-title');
        return;
      }

      match = PS.refineMatchWithEffectiveMotor(match);

      PS.state.currentMatches = [match];
      PS.state.currentSelectedIndex = 0;
      PS.state.focusedMatchIndex = null;
      PS.state.visibleMatchIndexes = new Set([0]);
      PS.state.dutyPointVisible = false;
      PS.state.openAdjustSections = new Set();
      PS.state.dutyPoints = [];

      PS.drawChart('model-chart', 'model', [match], new Set([0]), PS.state.detailModes, 0);
      PS.renderDetailSummary('model-detail-summary', match, 'model-pump-title');
      PS.renderAdjustmentPanel('model-adjustment-panel', match, 'model-chart', 'model', 'model-detail-summary');
      PS.updateChartModeAvailability(match, 'model');
    });

    on('pump-next-btn', 'click', PS.showDetailView);
    on('pump-back-btn', 'click', PS.showResultsView);
    on('duty-back-btn', 'click', () => {
      PS.showDutyInputView();

      // Deliberately going back to a blank duty form should invalidate a
      // saved duty-results/detail session - otherwise refreshing from here
      // would jump straight back to whatever was last viewed instead of
      // staying on the input form the user just asked for.
      PS.saveSession();
    });

    PS.setMode('duty');

    // A shared link (?pump=...) takes priority over a leftover session, since
    // opening one is a deliberate "show me this exact result" action. Either
    // falls through to the default duty-input view set above if there's
    // nothing usable to restore.
    if (!PS.restoreFromUrl()) {
      PS.restoreSession();
    }

    // A restored session/link may carry a saved Basic/Advanced preference -
    // reflect it on the header toggle now that state is settled.
    PS.syncModeToggleButtons();
  } catch (error) {
    // Show the error in a visible location — pump-result is inside a hidden
    // view so a load-time failure would be invisible and leave all buttons
    // unwired (nothing happens when clicked).
    const categoryView = document.getElementById('category-view');
    if (categoryView) {
      const msg = document.createElement('p');
      msg.style.cssText = 'color:red;font-weight:bold;margin-top:1rem;';
      msg.textContent = `Failed to load pump data: ${error.message}`;
      categoryView.appendChild(msg);
    }

    const result = document.getElementById('pump-result');
    if (result) {
      result.innerHTML = `<strong>Error:</strong> ${error.message}`;
    }

    console.error(error);
  }
});
